"use strict";

require("core-js/modules/es6.object.define-property");

Object.defineProperty(exports, "__esModule", {
  value: true
});
/**
 * Recursively parses object and populates value is node from
 * "#text" key if it's available
 */

exports.getValueFromTextNode = function (obj) {
  var textNodeName = "#text";

  for (var key in obj) {
    if (obj.hasOwnProperty(key) && obj[key][textNodeName] !== undefined) {
      obj[key] = obj[key][textNodeName];
    } else if (typeof obj[key] === "object" && obj[key] !== null) {
      obj[key] = exports.getValueFromTextNode(obj[key]);
    }
  }

  return obj;
};